import { render, staticRenderFns } from "./CompletionRenderer.vue?vue&type=template&id=7a284100&"
import script from "./CompletionRenderer.vue?vue&type=script&lang=js&"
export * from "./CompletionRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports